import { render, staticRenderFns } from "./MapaGestaoMunicipal.vue?vue&type=template&id=764aff8d&"
import script from "./MapaGestaoMunicipal.vue?vue&type=script&lang=js&"
export * from "./MapaGestaoMunicipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports